import type { PropsWithChildren } from 'react'

import { DetailBannerContainer } from './styled'

interface DetailBannerProps extends PropsWithChildren {
  slideLength?: number
}

export function DetailBanner({ children, slideLength = 1 }: DetailBannerProps) {
  return <DetailBannerContainer $slideLength={slideLength}>{children}</DetailBannerContainer>
}
